import React from 'react'
import EmptyCoin from '../../../assets/icons/empty-coin.svg'
import EmptyNote from '../../../assets/icons/empty-note.svg'

type CoupureIconProps = {
    value: number;
    cn: string
}

const CoupureIcon = ({value=0, cn='c'}:CoupureIconProps) => {

    function shortenNumber(num:number) {
        const abbreviations = [
            { value: 1e12, symbol: 'T' },
            { value: 1e9, symbol: 'B' },
            { value: 1e6, symbol: 'M' },
            { value: 1e3, symbol: 'K' }
        ];
        
        for (let i = 0; i < abbreviations.length; i++) {
            if (num >= abbreviations[i].value) {
                let shortened = (num / abbreviations[i].value).toFixed(1);
                if (shortened.endsWith('.0')) {
                shortened = shortened.slice(0, -2);
                }
                return shortened + abbreviations[i].symbol;
            }
        }
    
        return num.toString();
      }

    if(cn.toLowerCase() === 'c'){
        return (
        <div className='relative flex items-center justify-center w-8 h-8 min-w-8 min-h-8'>
            <img src={EmptyCoin} className='absolute w-full h-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2' alt="empty-coin" />
            <p className='relative z-10 text-[8px] select-none'>{shortenNumber(value)}</p>
        </div>
        )
    }

    else if(cn.toLowerCase() === 'n'){
        return (
        <div className='relative flex items-center justify-center w-8 h-8 min-w-8 min-h-8'>
            <img src={EmptyNote} className='absolute w-full h-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2' alt="empty-coin" />
            <p className='relative z-10 text-[8px] select-none'>{shortenNumber(value)}</p>
        </div>
        )
    }

    return <></>
}

export default CoupureIcon